const Modal = ({ isOpen, onClose, children, title }) => {
    if (!isOpen) {
      return null;
    }
  
    return (
      <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center z-[999]">
        {/* MODAL UI IMPROVEMENT: Changed max-w-lg to max-w-xl and added a subtle border */}
        <div className="relative p-8 bg-white w-full max-w-xl mx-auto rounded-lg shadow-xl animate-scale-in border border-gray-200">
          <div className="flex justify-between items-center pb-4 border-b">
            <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div className="mt-6">
            {children}
          </div>
        </div>
        <style>{`
          @keyframes scaleIn {
            from { transform: scale(0.95); opacity: 0; }
            to { transform: scale(1); opacity: 1; }
          }
          .animate-scale-in {
            animation: scaleIn 0.2s ease-out forwards;
          }
        `}</style>
      </div>
    );
  };

  export default Modal;